import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "download"]

  radioTargetConnected() {
    this.#refresh()
  }

  select() {
    this.#refresh()
  }

  #refresh() {
    this.radioTargets.forEach((radio, index) => {
      this.downloadTargets[index].classList.toggle("d-none", !radio.checked)
    })
  }
}
